import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import SocialLink from "../social-link/social-link";
import styles from "./social-link-list.module.css";
var SocialLinkList = function(param) {
    var links = param.links;
    return /*#__PURE__*/ _jsx("ul", {
        className: styles.list,
        children: links.map(function(props) {
            return /*#__PURE__*/ _jsx(SocialLink, _object_spread({}, props), props.name);
        })
    });
};
export default SocialLinkList;
